import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'sleepHours'

export default function SleepHoursPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the answer value from the form
    const formData = new FormData(event.currentTarget)
    const selectedValue = formData.get('answer') as string

    if (!selectedValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: t('pages.onboarding.sleepHours.heading', { lng: 'en' }),
      answer_key: selectedValue,
      answer: selectedValue,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  // Sleep hours options
  const getSleepHoursOptions = () => [
    {
      value: 'Less than 5 hours',
      translationKey: 'pages.onboarding.sleepHours.options.lessThan5',
      subtextKey: 'pages.onboarding.sleepHours.subtexts.lessThan5',
      emoji: '🕒',
    },
    {
      value: '5–6 hours',
      translationKey: 'pages.onboarding.sleepHours.options.5to6',
      subtextKey: 'pages.onboarding.sleepHours.subtexts.5to6',
      emoji: '🕓',
    },
    {
      value: '6–7 hours',
      translationKey: 'pages.onboarding.sleepHours.options.6to7',
      subtextKey: 'pages.onboarding.sleepHours.subtexts.6to7',
      emoji: '🕔',
    },
    {
      value: '7–8 hours',
      translationKey: 'pages.onboarding.sleepHours.options.7to8',
      subtextKey: 'pages.onboarding.sleepHours.subtexts.7to8',
      emoji: '🕓',
    },
    {
      value: '8+ hours',
      translationKey: 'pages.onboarding.sleepHours.options.moreThan8',
      subtextKey: 'pages.onboarding.sleepHours.subtexts.moreThan8',
      emoji: '🕓',
    },
  ]

  // Get the options
  const options = getSleepHoursOptions()

  // Transform options to the format expected by QuestionPage
  const buttons = options.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    subtext: t(option.subtextKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.sleepHours.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
    />
  )
}
